import {
  endOfMonth,
  format,
  startOfMonth,
  startOfYear,
  subDays,
  subMonths,
} from 'date-fns';

const RANGE_PRESETS = [
  {
    key: 'mes_atual',
    label: 'Mes atual',
    getValue: (today) => ({
      startDate: format(startOfMonth(today), 'yyyy-MM-dd'),
      endDate: format(today, 'yyyy-MM-dd'),
    }),
  },
  {
    key: 'mes_anterior',
    label: 'Mes anterior',
    getValue: (today) => {
      const previousMonth = subMonths(today, 1);
      return {
        startDate: format(startOfMonth(previousMonth), 'yyyy-MM-dd'),
        endDate: format(endOfMonth(previousMonth), 'yyyy-MM-dd'),
      };
    },
  },
  {
    key: 'ultimos_7_dias',
    label: 'Ultimos 7 dias',
    getValue: (today) => ({
      startDate: format(subDays(today, 6), 'yyyy-MM-dd'),
      endDate: format(today, 'yyyy-MM-dd'),
    }),
  },
  {
    key: 'ultimos_30_dias',
    label: 'Ultimos 30 dias',
    getValue: (today) => ({
      startDate: format(subDays(today, 29), 'yyyy-MM-dd'),
      endDate: format(today, 'yyyy-MM-dd'),
    }),
  },
  {
    key: 'ano_atual',
    label: 'Ano atual',
    getValue: (today) => ({
      startDate: format(startOfYear(today), 'yyyy-MM-dd'),
      endDate: format(today, 'yyyy-MM-dd'),
    }),
  },
];

const SINGLE_PRESETS = [
  {
    key: 'hoje',
    label: 'Hoje',
    getValue: (today) => format(today, 'yyyy-MM-dd'),
  },
  {
    key: 'ontem',
    label: 'Ontem',
    getValue: (today) => format(subDays(today, 1), 'yyyy-MM-dd'),
  },
  {
    key: 'inicio_mes',
    label: 'Inicio do mes',
    getValue: (today) => format(startOfMonth(today), 'yyyy-MM-dd'),
  },
  {
    key: 'fim_mes',
    label: 'Fim do mes',
    getValue: (today) => format(endOfMonth(today), 'yyyy-MM-dd'),
  },
  {
    key: 'fim_mes_anterior',
    label: 'Fim mes anterior',
    getValue: (today) => format(endOfMonth(subMonths(today, 1)), 'yyyy-MM-dd'),
  },
];

const baseButtonClass =
  'px-2.5 py-1 rounded-full border text-xs font-medium transition-colors';
const inactiveButtonClass =
  'border-gray-200 bg-white text-gray-700 hover:bg-gray-50';
const activeButtonClass = 'border-primary-300 bg-primary-50 text-primary-700';

const DateQuickPresets = ({
  mode = 'range',
  startDate,
  endDate,
  date,
  onSelect,
  className = '',
}) => {
  const today = new Date();
  const presets = mode === 'single' ? SINGLE_PRESETS : RANGE_PRESETS;

  return (
    <div className={className}>
      <div className="text-xs font-medium text-gray-500 mb-2">Atalhos de data</div>
      <div className="flex flex-wrap gap-2">
        {presets.map((preset) => {
          if (mode === 'single') {
            const presetDate = preset.getValue(today);
            const isActive = presetDate === date;
            return (
              <button
                key={preset.key}
                type="button"
                onClick={() => onSelect?.({ key: preset.key, date: presetDate })}
                className={`${baseButtonClass} ${isActive ? activeButtonClass : inactiveButtonClass}`}
              >
                {preset.label}
              </button>
            );
          }

          const presetRange = preset.getValue(today);
          const isActive =
            presetRange.startDate === startDate && presetRange.endDate === endDate;
          return (
            <button
              key={preset.key}
              type="button"
              onClick={() =>
                onSelect?.({
                  key: preset.key,
                  startDate: presetRange.startDate,
                  endDate: presetRange.endDate,
                })
              }
              className={`${baseButtonClass} ${isActive ? activeButtonClass : inactiveButtonClass}`}
            >
              {preset.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default DateQuickPresets;
